var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242,
    height: 109.422,
    viewBox: "0 0 242 109.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\uD569\\uCE58\\uAE30_6",
    x: 0,
    y: 0,
    width: 242,
    height: 109.422,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21756",
    "data-name": "\\uADF8\\uB8F9 21756",
    transform: "translate(-407 -2819.578)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 407, 2819.58)",
    filter: "url(#\\uD569\\uCE58\\uAE30_6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_6-2",
    "data-name": "\\uD569\\uCE58\\uAE30 6",
    d: "M6286-4360.577a10,10,0,0,1-10-10v-60a10,10,0,0,1,10-10h111.322l4.447-11.422,4.448,11.422H6490a10,10,0,0,1,10,10v60a10,10,0,0,1-10,10Z",
    transform: "translate(-6267 4458)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC0C1\\uD488\\uD654_\\uBE44\\uC6A9_55_000\\uC6D0_\\uB099\\uCC30\\uC218\\uC218\\uB8CC\\uAC00_\\uD3EC\\uD568\\uB41C_\\uAC00\\uACA9\\uC785\\uB2C8\\uB2E4._",
    "data-name": "\\uC0C1\\uD488\\uD654 \\uBE44\\uC6A9 + 55,000\\uC6D0  (\\uB099\\uCC30\\uC218\\uC218\\uB8CC\\uAC00 \\uD3EC\\uD568\\uB41C \\uAC00\\uACA9\\uC785\\uB2C8\\uB2E4.)",
    transform: "translate(528 2873.5)",
    fill: "#868e96",
    fontSize: 16,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo",
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -74.431,
    y: 0
  }, "\uC0C1\uD488\uD654"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "\uBE44\uC6A9"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    xmlSpace: "preserve",
    fontFamily: "Helvetica"
  }, " + 55,000"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "\uC6D0"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica"
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -103.116,
    y: 22
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    y: 22,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, "\uB099\uCC30\uC218\uC218\uB8CC\uAC00"), /*#__PURE__*/React.createElement("tspan", {
    y: 22
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 22,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, "\uD3EC\uD568\uB41C"), /*#__PURE__*/React.createElement("tspan", {
    y: 22
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 22,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, "\uAC00\uACA9\uC785\uB2C8\uB2E4"), /*#__PURE__*/React.createElement("tspan", {
    y: 22
  }, ".)"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeduction);
export default __webpack_public_path__ + "static/media/Deduction.2db4257682e09961b6aba3605c75e3c1.svg";
export { ForwardRef as ReactComponent };